import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

function AddNewCountry() {
  const params = useParams();
  const [languageData, setLanguageData] = useState();

  const [initialVal, setInitialVal] = useState({
    country: "",
    nationality: "",
    is_default: 1,
    is_active: 1,
    // language_id: "",
  });
  const navigate = useNavigate();

  const getLanguageData = async () => {
    try {
      const resLang = await axios.get(
        `https://abarishr.hennainternational.in/api/language`
      );
      setLanguageData(resLang.data);
    } catch (error) {
      alert("wrog");
    }
  };

  const changeHandler = (e) => {
    const clone = { ...initialVal };
    const value = e.target.value;
    const name = e.target.name;
    clone[name] = value;
    setInitialVal(clone);
  };

  const getById = async (id) => {
    const res = await axios.get(
      `https://abarishr.hennainternational.in/api/countries/get/${params?.id}`
    );
    const clone = { ...res.data };
    setInitialVal(clone);
  };

  useEffect(() => {
    getLanguageData();
    if (params?.id) {
      getById();
    }
  }, []);

  const notify = (updateMassage) => toast(updateMassage);

  const handleAdd = async () => {
    try {
      const res = await axios.post(
        `https://abarishr.hennainternational.in/api/countries/add`,
        initialVal
      );
      notify("Add Successfull");
      setTimeout(() => {
        navigate("/admin/list-countries");
      }, 1000);
    } catch (error) { }
  };

  const updateHandle = async () => {
    try {
      const res = await axios.put(
        `https://abarishr.hennainternational.in/api/countries/update/${params.id}`,
        initialVal
      );
      notify("update Successfull");
      setTimeout(() => {
        navigate("/admin/list-countries");
      }, 1000);
    } catch (error) { }
  };
  return (
    <>
      <div className="pageTableWrapper">
        <ToastContainer />
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>COUNTRY FORM</h5>
          </div>
        </div>

        <div className="pageBody">
          <div className="pageTable">
            <form>
              {/* <div className="form-group mb-3">
                <label htmlFor="lang" className="mb-1">
                  <strong>Language</strong>
                </label>
                <select
                  className="form-select"
                  id="lang"
                  name="language_id"
                  onChange={changeHandler}
                  value={initialVal?.language_id}
                >
                  <option selected >
                    Select Language
                  </option>
                  {languageData &&
                    languageData?.map((item) => {
                      return (
                        <option value={item?._id} key={item._id}>
                          {item.lang}
                        </option>
                      );
                    })}
                </select>
              </div> */}
              <div className="form-group mb-3">
                <label htmlFor="language_level">
                  <strong>Country</strong>
                </label>
                <input
                  className="form-control"
                  id="language_level"
                  placeholder="Country"
                  name="country"
                  value={initialVal?.country}
                  onChange={changeHandler}
                  type="text"
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="language_level">
                  <strong>Nationality</strong>
                </label>
                <input
                  className="form-control"
                  id="language_level"
                  placeholder="Nationality"
                  type="text"
                  name="nationality"
                  value={initialVal?.nationality}
                  onChange={changeHandler}
                />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="is_default">
                  <strong>Is Default?</strong>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={1}
                    checked={Number(initialVal.is_default) === 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_yes">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_default"
                    value={0}
                    checked={Number(initialVal.is_default) === 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_default_no">
                    No
                  </label>
                </div>
              </div>

              {/* is_active */}
              <div className="form-group">
                <label htmlFor="is_active">
                  <strong>Active</strong>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={1}
                    checked={Number(initialVal.is_active) === 1}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_yes">
                    Active
                  </label>
                </div>
                <div className="form-check mt-1 mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="is_active"
                    value={0}
                    checked={Number(initialVal.is_active) === 0}
                    onChange={changeHandler}
                  />
                  <label className="form-check-label" htmlFor="is_active_no">
                    Inactive
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div className="pageFooter text-center mt-2">
          <button
            className="btn btn-large btn-primary"
            type="button"
            onClick={params.id ? updateHandle : handleAdd}
          >
            Update <BsFillArrowRightCircleFill />
          </button>
        </div>
      </div>
    </>
  );
}
export default AddNewCountry;
